import React from 'react'
import { Route, Switch } from 'react-router-dom'
import Index from './Index'

export default () => (
  <Switch>
    <Route exact path="/honeytoastlivestream-v2" component={Index} />
  </Switch>
)
